<div ngbDropdown class="d-inline-block">
  <button ngbDropdownToggle class="btn btn-dark">
    <i class="bi bi-bell"></i>
    <span class="badge bg-danger ms-1" *ngIf="hasUnseenNotifications">
      {{ unseenNotifications.length }}
    </span>
  </button>

  <div ngbDropdownMenu class="dropdown-menu-end notifications-menu">
    <div *ngIf="loading" class="p-2 text-center text-muted">Loading...</div>

    <ng-container *ngIf="!loading && notificationsResults">
      <button 
        *ngFor="let n of notificationsResults.notifications"
        ngbDropdownItem
        [class.fw-bold]="!n.isSeen"
        (click)="notificationClicked(n.id)">
        {{ n.content }}
        <br />
        <small class="text-muted">{{ n.dateCreated | date:'short' }}</small>
      </button>
    </ng-container>

    <div *ngIf="!loading && notificationsResults?.notifications?.length == 0" class="p-2 text-center text-light">
      No notifications
    </div>

    <div class="dropdown-divider mt-1"></div>
    <div class="p-2 text-center">
      <button class="btn btn-link p-0" (click)="goToNotificationsPage()" ngbDropdownItem>
        View all
      </button>
    </div>
  </div>
</div>